import { businessErrorFactory, BusinessError } from '../../../../../common/business-error';

import { BUSINESS_ERRORS } from './interfaces';

const APP_INVALID_URL = 'WAP App with given URL has invalid format. Please try again with different URL.';

const INVALID_SMS_TEMPLATE =
  // eslint-disable-next-line max-len
  'Invalid sms template, it must start contains `{link}`';

const EDIT_APP_NOT_FOUND =
  // eslint-disable-next-line max-len
  'WAP App with given id not exists. Please refresh the page and try again. If the problem still persists, contact with support.';

const EDIT_APP_UNEXPECTED_ERROR =
  'Sorry your App could not be edited. Please try again. If the problem still persists, contact with support.';

export const getEditAppBusinessError = (businessError: BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.APP_INVALID_URL: {
      return businessErrorFactory({ message: APP_INVALID_URL, severity: 'warning' });
    }
    case BUSINESS_ERRORS.APP_NOT_FOUND: {
      return businessErrorFactory({ message: EDIT_APP_NOT_FOUND, severity: 'warning' });
    }
    case BUSINESS_ERRORS.INVALID_SMS_TEMPLATE: {
      return businessErrorFactory({ message: INVALID_SMS_TEMPLATE, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({ message: EDIT_APP_UNEXPECTED_ERROR, severity: 'error' });
    }
  }
};
